export { default } from "./Duration";
